module.exports = __webpack_public_path__ + "img/SeeFail.7248bf30.png";